import { datadogLogs } from '@datadog/browser-logs'

export default function init() {
  const cfg = window.DD_RUM?.getInitConfiguration()

  if (cfg) {
    const {
      clientToken,
      site = 'datadoghq.com',
      service,
      sessionSampleRate,
      version,
      env,
    } = cfg
    datadogLogs.init({
      clientToken,
      site,
      service,
      forwardErrorsToLogs: false,
      sessionSampleRate: sessionSampleRate || 100,
      useSecureSessionCookie: true,
      version,
      env,
    })

    window.DD_LOGS = datadogLogs
  }
}
